// Browse lane copy (features 10/16). Drafted by Astra (GPT-6, copy lane) on 10/16 from the brief in
// build/astra/browse-copy-brief-1016.md, two rounds (raw output beside it); gated by Claude: every key present,
// placeholders kept, no dashes / exclamation marks / curly quotes, "activities" not "listings", the fixed fame names
// (Well known / Local favorites / Under the radar) and the "Go with others" row title kept. Its own file so the lane
// merges cleanly with the other copy files.
export const FB = {
  // R-08 fame filter (AGENTS.md Core flow: well known, local favorites, under the radar)
  'fb.fame.legend': "How known is it?",
  'fb.fame.well': "Well known",
  'fb.fame.local': "Local favorites",
  'fb.fame.radar': "Under the radar",
  'fb.fame.tip': "Pick none for a good mix, including small, one-off activities most lists miss.",
  // R-94 words filter (alvin's pin 565)
  'fb.words.legend': "Filter by words",
  'fb.words.include': "Show activities with any of",
  'fb.words.exclude': "Hide activities with any of",
  'fb.words.include_placeholder': "Try jazz or pottery",
  'fb.words.exclude_placeholder': "Try tech week",
  'fb.words.add': "Add word",
  'fb.words.remove': "Remove word: {word}",
  'fb.words.tip': "Words match activity names, venues and source sites, and are saved only on this device.",
  'fb.words.full': "This word list is full. Remove a word to add another.",
  // "Hide this kind" on an activity's detail
  'fb.hide_kind': "Hide all activities from {kind}",
  'fb.hid_kind': "Activities from {kind} are hidden. Bring them back in Filters.",
  'fb.undo': "Undo",
  // R-15 tips: why each choice sharpens the picks
  'fb.tip.when': "Choose dates to narrow activities, or Any time to see everything.",
  'fb.tip.category': "Choose categories to see only activities in those categories.",
  'fb.tip.price': "Choose Free to see only free activities.",
  'fb.tip.setting': "Choose indoors or outdoors to suit the weather.",
  // R-05 ask in your own words on Browse
  'fb.ask.placeholder': "What would you like to do?",
  'fb.ask.eyebrow': "What you asked for",
  'fb.ask.clear': "Clear",
  'fb.ask.clear_label': "Clear your request and show all activities",
  'fb.ask.loading': "Finding activities",
  'fb.ask.error': "Something went wrong. Please try again soon.",
  'fb.ask.limit': "You have reached today's limit. Try again tomorrow.",
  'fb.ask.loose': "Few activities matched every word, so we included close matches.",
  'fb.ask.empty': "No activities matched. Try fewer words.",
  // R-06 map view
  'fb.map.label': "Map of activities",
  'fb.map.none': "These activities have no map location.",
  'fb.map.missing_one': "1 activity has no map location. See it in List.",
  'fb.map.missing_other': "{count} activities have no map location. See them in List.",
  'fb.map.shown': "The first {count} activities are on the map. Tap Show more for the rest.",
  // R-30 go with others (AGENTS.md Purpose: less lonely, next to other people)
  'fb.people.title': "Go with others",
  'fb.people.note': "Activities to do alongside other people.",
  'fb.people.card': "With other people",
} as const

export type FbKey = keyof typeof FB
/** A Browse lane line, with {placeholders} filled. */
export const fb = (k: FbKey, vars: Record<string, string | number> = {}): string =>
  FB[k].replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m))
